module.exports = __webpack_public_path__ + "assets/mp3/audio6/audio_6_2a.mp3";